import Image from "next/image";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { formatImageUrl } from "../../../helper/helper";

const NewOctaveBanner = (props: any) => {
  let logoImage: any = formatImageUrl(
    props?.data?.media?.data?.attributes?.url
  );
  let bottleImage: any = formatImageUrl(
    props?.data?.bottle_image?.data?.attributes?.url
  );
  let desktopBanner: any = formatImageUrl(
    props?.data?.banner?.data?.attributes?.url
  );
  let mobileBanner: any = formatImageUrl(
    props?.data?.banner_mobile?.data?.attributes?.url ||
      props?.data?.banner?.data?.attributes?.url
  );
  return (
    <section
      className={`octave_collection_new_section${
        props?.responsiveBanner ? " has-responsive-banner" : ""
      }`}
    >
      {props?.responsiveBanner && desktopBanner ? (
        <img
          src={desktopBanner}
          alt=""
          className="octave_banner_bg desktop-img"
        />
      ) : null}
      {props?.responsiveBanner && mobileBanner ? (
        <img
          src={mobileBanner}
          alt=""
          className="octave_banner_bg mobile-img"
        />
      ) : null}
      <div className="collection_container">
        <div className="octave_collection_new_inner_div">
          <Row>
            <Col md={6}>
              <div className={`octave_banner_logo_section`}>
                {props?.data?.media?.data && (
                  <img
                    src={logoImage}
                    alt={`octave logo`}
                    className={`collection_new_logo`}
                  />
                )}
              </div>
            </Col>
            <Col md={6}>
              <div className="octave_new_product_img_section">
                {props?.data?.bottle_image?.data && (
                  <img
                    src={bottleImage}
                    alt={`octave logo`}
                    className={`${props?.mainBottleImg}`}
                  />
                )}
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </section>
  );
};

export default NewOctaveBanner;
